import { makeAutoObservable } from 'mobx';
import { MobXProviderContext } from 'mobx-react';
import { useContext } from 'react';
import { ThemeStore } from './theme';
import { CommonStore } from './common';

export class AppStore {
    themeStore: ThemeStore;
    commonStore: CommonStore;

    constructor() {
        makeAutoObservable(this);
        this.themeStore = new ThemeStore();
        this.commonStore = new CommonStore();
    }
}

export const useAppStore = (): AppStore => {
    const context = useContext(MobXProviderContext);
    return context.store;
};
